import Avatar from '@/components/linear/avatar';
import PriorityIcon from '@/components/linear/priority-icon';
import StatusIcon from '@/components/linear/status-icon';
import { openIssuePath } from '@/lib/linear-paths';
import { formatCompactTime } from '@/lib/time';
import type { Issue } from '@/types/issue';
import { Link } from '@inertiajs/react';

interface Props {
  issue: Issue;
  selected?: boolean;
  href?: string;
  onSelect?: (issue: Issue) => void;
}

export default function IssueRow({ issue, selected = false, href, onSelect }: Props) {
  const destination = href ?? openIssuePath(issue);

  return (
    <Link
      href={destination}
      className="ln-row"
      data-selected={selected ? 'true' : 'false'}
      onClick={(event) => {
        if (onSelect) {
          event.preventDefault();
          onSelect(issue);
        }
      }}
    >
      <PriorityIcon priority={issue.priority} />
      <span className="ln-row-id">{issue.identifier}</span>
      <StatusIcon status={issue.status} />
      <span className="ln-row-title">{issue.title}</span>
      <span className="ln-row-meta">
        {issue.labels?.map((label) => (
          <span
            key={label.id}
            className="ln-label"
            style={{ color: label.color, background: `${label.color}22` }}
          >
            {label.name}
          </span>
        ))}
        {issue.cycle ? <span className="ln-label">{issue.cycle.name}</span> : null}
        <span className="ln-row-date">
          {formatCompactTime(issue.dueOn || issue.updatedAt || issue.createdAt)}
        </span>
        {issue.assignee ? (
          <Avatar name={issue.assignee.name} color={issue.assignee.avatarColor} size={18} />
        ) : null}
      </span>
    </Link>
  );
}
